import React from 'react';
import { AssetStoryblok } from '../../../../types/storyblok';

export type VectorImageProps = {
  src: AssetStoryblok | undefined;
  alt: string;
  className?: string;
};

export const VectorImage = ({ src, alt, className }: VectorImageProps) => {
  return <img src={src?.filename} alt={alt || ''} className={className} />;
};
